export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "Der Dozent/Die Dozentin war engagiert und motiviert.",
			},
			{
				id: 2,
				text: "Der Dozent/Die Dozentin hat die Inhalte angemessen präsentiert und wiederholt.",
			},
			{
				id: 3,
				text: "Ich konnte dem Tempo des Dozenten/der Dozentin gut folgen.",
			},
			{
				id: 4,
				text: "Der Dozent ermöglichte eine gute Lern- und Arbeitsatmosphäre.",
			},
			{
				id: 5,
				text: "Der Dozent/Die Dozentin gab die Möglichkeit Fragen zu stellen.",
			},
			{
				id: 6,
				text: "Der Dozent/Die Dozentin war stets gut vorbereitet.",
			},
			{
				id: 7,
				text: "Der Dozent/Die Dozentin konnte Kompliziertes verständlich machen.",
			},
			{
				id: 8,
				text: "Dem Dozenten/Der Dozentin war es wichtig, dass die Teilnehmer/innen etwas lernen.",
			},
			{
				id: 9,
				text: "Der Dozent/Die Dozentin hat die Inhalte interessant vermittelt.",
			},
			{
				id: 10,
				text: "Das von dem Dozenten/der Dozentin zur Verfügung gestellte Material bzw. die von ihm/ihr eingesetzten Medien waren hilfreich.",
			},
			{
				id: 11,
				text: "Das Betreuungsangebot des Dozenten/der Dozentin (z.B. im Rahmen von Sprechstunden) war ausreichend.",
			},
			{
				id: 12,
				text: "Die angestrebten Lernziele wurden von vorneherein gut definiert.",
			},
			{
				id: 13,
				text: "Die Veranstaltung war übersichtlich und verständlich.",
			},
			{
				id: 14,
				text: "Der inhaltliche Aufbau der Veranstaltung war logisch/nachvollziehbar.",
			},
			{
				id: 15,
				text: "Ich habe in der Veranstaltung Wichtiges gelernt.",
			},
			{
				id: 16,
				text: "Ich habe in der Veranstaltung wichtige Kompetenzen weiterentwickelt.",
			},
			{
				id: 17,
				text: "Die vermittelten Kompetenzen sind für meine persönliche Entwicklung relevant.",
			},
			{
				id: 18,
				text: "Die Schwierigkeit des Stoffes war angemessen.",
			},
			{
				id: 19,
				text: "Der Umfang des Stoffes war angemessen.",
			},
			{
				id: 20,
				text: "Das Tempo der Veranstaltung war angemessen.",
			},
			{
				id: 21,
				text: "Die Anforderungen der Veranstaltung waren angemessen.",
			},
			{
				id: 22,
				text: "Der Zeitaufwand für die Veranstaltung insgesamt (inkl. Vor- und Nachbereitung) war angemessen.",
			},
			{
				id: 23,
				text: "Insgesamt hat mich die Veranstaltung überfordert.",
			},
			{
				id: 24,
				text: "Ich habe viel Zeit in die Vor- und Nachbereitung der Veranstaltung investiert.",
			},
			{
				id: 25,
				text: "Ich habe die behandelten Texte/Materialien regelmäßig vorbereitet.",
			},
			{
				id: 26,
				text: "Ich habe aus eigener Initiative Literatur zum Stoff der Veranstaltung gelesen.",
			},
			{
				id: 27,
				text: "Ich habe in die Veranstaltung mehr Zeit investiert als in vergleichbare Kurse.",
			},
			{
				id: 28,
				text: "Ich habe mich aktiv in die Veranstaltung eingebracht.",
			},
			{
				id: 29,
				text: "Die Arbeit im Seminar (Diskussionen, Gruppenarbeiten, Textarbeiten, Hausaufgaben etc.) hat mein Verständnis der Inhalte vertieft.",
			},
			{
				id: 30,
				text: "Das Seminar verdeutlichte die Relevanz der behandelten Themen.",
			},
			{
				id: 31,
				text: "Ich wurde durch das Seminar zum Mitdenken motiviert.",
			},
			{
				id: 32,
				text: "Zur kritischen Auseinandersetzung mit den behandelten Themen wurde ich durch die Arbeit im Seminar angeregt.",
			},
			{
				id: 33,
				text: "Das Seminar motivierte dazu, sich selbst mit den Inhalten zu beschäftigen.",
			},
			{
				id: 34,
				text: "Die gemeinsame Seminararbeit war produktiv.",
			},
			{
				id: 35,
				text: "Insgesamt fand ich die Veranstaltung gut.",
			},
			{
				id: 36,
				text: "In der Veranstaltung habe ich viel gelernt.",
			},
			{
				id: 37,
				text: "Meine Erwartungen an die Veranstaltung wurden erfüllt.",
			},
			{
				id: 38,
				text: "Ich würde die Veranstaltung weiterempfehlen.",
			},
		],
	},
	{
		type: "text",
		id: 2,
		items: [
			{
				id: 39,
				text: "Anmerkungen",
			},
		],
	},
];
